import React from 'react';
import GraphAndTableAnalytics from './GraphAndTableAnalytics';
import { useSelector } from 'react-redux';

export default function ProjectAnalytics({ bgcolor }) {
  const projectTrend = useSelector((state) => state.pointTracker.projectTrend.data);
  const projectTrendLoading = useSelector((state) => state.pointTracker.projectTrend.loading);
  return (
    <GraphAndTableAnalytics
      bgcolor={bgcolor}
      loading={projectTrendLoading}
      rows={[...(projectTrend?.trends || []), { month: 'TOTAL', ...(projectTrend?.totals || {}) }]}
    />
  );
}
